module.exports = __webpack_public_path__ + "media/images/riders/CHARLIE_HATTON-a9d440dc44260eb5016e83bd71745faf.png";